import '../../text-field/style';
import '../../text-area/style';
// style dependencies
import '../../modal-container/style';
import './index.less';
